import { render } from "./loading.vue?vue&type=template&id=7bcb26e2&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=7bcb26e2&scoped=true&lang=css"

import exportComponent from "D:\\tiansc\\palette\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bcb26e2"]])

export default __exports__